import './debugMenu.scss';
import OverlayModal from '@/comp/overlayModal/overlayModal';
import { Dispatch, useContext, useState } from 'react';
import Button from '@/comp/button/button';
import * as storage from '@/_helper/storage';
import { AppContext } from '@/context/AppContext';
import { BookingState, isBookingState } from '@/model/common/BookingData';
import ToggleSwitch from '@/comp/toggleSwitch/toggleSwitch';
import { ChangeMediatedPostpay } from '@/comp/debugMenu/comp/debugMediatedPostPay';
import { Icon } from '@/comp/icon/icon';
import { STORAGE_NAME_DEBUG_BOOKING_STATE, STORAGE_NAME_DEBUG_MODE } from '@/constants/debug';

export const DebugMenu = () => {
    const storageDebugEnabled = storage.get(STORAGE_NAME_DEBUG_MODE);
    const { bookingState: initialBookingState, bookingData: initialData, saveBookingData } = useContext(AppContext);
    const [bookingData, setBookingData] = useState(initialData);
    const [modalOpen, setModalOpen] = useState(false);
    const [debugEnabled, setDebugEnabled] = useState(storageDebugEnabled || false);
    const [bookingState, setBookingState] = useState(initialBookingState);

    const handleSave = () => {
        if (bookingData) {
            saveBookingData(bookingData);
        }

        storage.set(STORAGE_NAME_DEBUG_MODE, debugEnabled);
        storage.set(STORAGE_NAME_DEBUG_BOOKING_STATE, bookingState);

        window.location.reload();
    };

    const handleReset = () => {
        storage.remove(STORAGE_NAME_DEBUG_MODE);
        storage.remove(STORAGE_NAME_DEBUG_BOOKING_STATE);
        window.location.reload();
    };

    if (!bookingData) {
        return null;
    }

    return (
        <div className="debug-menu-container">
            <div className="debug-menu" onClick={() => setModalOpen(true)}>
                <Icon name="settings" ariaHidden />
            </div>
            {modalOpen && (
                <OverlayModal name="debugMenu" toggleModal={() => setModalOpen(!modalOpen)}>
                    <div className="toggle-container">
                        <ToggleSwitch checked={debugEnabled} onChange={setDebugEnabled} label="Debug Mode" />
                    </div>
                    <div>
                        <p>
                            Wenn alle Strecken zu sehen sein sollen, bitte Debug Mode anschalten. Wenn einzelne
                            BookingStates angezeigt werden sollen, dann bitte den jeweiligen State auswählen.
                        </p>
                        <p>
                            Dabei gilt:
                            <br /> OK: Reise OK
                            <br /> XX: Reise storniert
                            <br /> over: Reise in der Vergangenheit
                            <br /> NO: Buchung ist NO
                        </p>
                    </div>
                    {bookingState && (
                        <ChangeBookingState bookingState={bookingState} setBookingState={setBookingState} />
                    )}

                    <ChangeMediatedPostpay bookingData={bookingData} setBookingData={setBookingData} />

                    <div className="modal-button-container">
                        <Button label={'Speichern'} handleClick={handleSave} />
                        <Button label={'BookingState Zurücksetzen'} handleClick={handleReset} />
                    </div>
                </OverlayModal>
            )}
        </div>
    );
};

const ChangeBookingState = ({
    bookingState,
    setBookingState,
}: {
    bookingState: BookingState;
    setBookingState: Dispatch<BookingState>;
}) => {
    const handleChange = (bookingState: string) => {
        if (isBookingState(bookingState)) {
            setBookingState(bookingState);
        }
    };

    return (
        <div className="debug-booking-state">
            Bookingstate{' '}
            <select defaultValue={bookingState} onChange={(e) => handleChange(e.target.value)}>
                <option value={'OK'}>OK</option>
                <option value={'XX'}>XX</option>
                <option value={'over'}>over</option>
                <option value={'NO'}>NO</option>
            </select>
        </div>
    );
};
